import { render, staticRenderFns } from "./FetchError.vue?vue&type=template&id=89ecea4a&"
import script from "./FetchError.vue?vue&type=script&lang=js&"
export * from "./FetchError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports